// Define party colors
export const partyColors: Record<string, string> = {
  NPP: "#020297", // Blue
  NDC: "#4CAF50", // Green
  GUM: "#644436FF", // Red
  CPP: "#CB0F01FF", // Yellow
  PNC: "#F49005FF", // Yellow
  PPP: "#F6827AFF", // Yellow
};

// Define candidates
export const candidates = {
  NPP: {
    name: "",
    image: "data/img/.png",
    party: "New Patriotic Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NPP.png",
  },
  NDC: {
    name: "",
    image: "data/img/.jpg",
    party: "National Democratic Congress",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },
  GUM: {
    name: "",
    image: null,
    party: "Ghana Union Movement",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/GUM.png",
  },
  CPP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/CPP.png",
  },
  APC: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/APC.png",
  },
  DPP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/DPP.png",
  },
  EGLE: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/EGLE.png",
  },
  GCPP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/GCPP.png",
  },
  GFP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/GFP.png",
  },
  IPP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },
  LPG: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },

  NDP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },
  NRP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },
  PPP: {
    name: "",
    image: "data/img/Ivor Greenstreet.jpg",
    party: "Convention People's Party",
    partyLogo:
      "https://ecdataanalysis.s3.eu-central-1.amazonaws.com/Party+Logos/Party+Logos/NDC.png",
  },
};
